import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLeads from "@/pages/AdminLeads";
import { ThemeProvider } from "@/lib/theme";
import SmoothScroll from "@/components/site/SmoothScroll";
import Cursor from "@/components/site/Cursor";
import Loader from "@/components/site/Loader";

function AnimatedRoutes() {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={location.pathname}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
            >
                <Routes location={location}>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin/leads" element={<AdminLeads />} />
                </Routes>
            </motion.div>
        </AnimatePresence>
    );
}

function App() {
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.slice(1);
            const el = document.getElementById(id);
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 400);
        }
    }, []);

    return (
        <ThemeProvider>
            <Loader />
            <Cursor />
            <SmoothScroll>
                <div className="App">
                    <BrowserRouter>
                        <AnimatedRoutes />
                    </BrowserRouter>
                    <Toaster
                        position="bottom-right"
                        richColors
                        theme="system"
                        toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }}
                    />
                </div>
            </SmoothScroll>
        </ThemeProvider>
    );
}

export default App;
